async function loginUser(username, password) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/loginPolice`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',         
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username, password })
    });

    if (response.status === 401) {
      throw new Error('Invalid credentials');
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error('Login failed', error);
    throw error;
  }
}

async function logoutUser() {
  const url = `${process.env.REACT_APP_API_URL}/Auth/logout`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',           
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 401) {
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();

  } catch (error) {
    console.error('Logout failed', error);
    throw error;
  }
}

export default { loginUser, logoutUser };
